/** Grouped account links — used by navbar dropdowns and account area sidebar. */
export const ACCOUNT_MENU_GROUPS = [
  {
    label: 'Your account',
    items: [
      { to: '/account', label: 'My Profile', end: true },
      { to: '/account/orders', label: 'My Orders' },
      { to: '/account/addresses', label: 'Delivery Addresses' },
    ],
  },
  {
    label: 'Plans',
    items: [
      { to: '/account/subscriptions', label: 'Subscriptions' },
      { to: '/account/bulk-orders', label: 'Bulk Orders' },
    ],
  },
  {
    label: 'Security',
    items: [
      // 'Forgot password' is intentionally omitted here: this menu only renders for
      // signed-in users (account sidebar + navbar dropdown). Logged-out recovery is
      // available from the Navbar login modal's "Forgot password?" link.
      // 'Change password' is the primary option for signed-in users (knows current
      // password); 'Reset password' stays as an OTP-based fallback.
      { to: '/account/change-password', label: 'Change password' },
      { to: '/account/reset-password', label: 'Reset password' },
    ],
  },
];

export const ACCOUNT_DELETE_PATH = '/account/delete';
